import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import shared from './shared'
import platforms from './platforms'
import wizard from './wizard'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    user: user,
    shared: shared,
    wizard: wizard,
    platforms: platforms
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js